
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M473.6 215.55a17.103 17.103 0 008.498-14.778V127.75A17.096 17.096 0 00465 110.652H349.098v28.5a17.098 17.098 0 11-34.196 0v-28.5H47a17.096 17.096 0 00-17.098 17.098v73.022a17.103 17.103 0 008.498 14.779 46.502 46.502 0 01-.01 80.908 17.095 17.095 0 00-8.488 14.778v73.013A17.096 17.096 0 0047 401.348h267.902v-28.5a17.098 17.098 0 1134.196 0v28.5H465a17.096 17.096 0 0017.098-17.098v-73.013a17.103 17.103 0 00-8.498-14.779 46.506 46.506 0 010-80.907zm-124.502 98.4a17.098 17.098 0 11-34.196 0v-28.5a17.098 17.098 0 1134.196 0zm0-87.401a17.098 17.098 0 11-34.196 0v-28.5a17.098 17.098 0 1134.196 0z"}})])
          )
        }
      }
    